// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages45_root__3aJ-D","title":"AfterImages45_title__2vvWD","images":"AfterImages45_images__2MiCl"};